var React = require('react');

function MessageInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"}));
}

MessageInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"#ffffff","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-message-square"};

module.exports = MessageInline;

MessageInline.default = MessageInline;
